module.exports = __webpack_public_path__ + "img/Lumina_island.4b5d1d74.png";